import { FormLabel } from '@/components/FormLabel'
import type { AdditionalPolicyHolderInfoFormProps } from '@/containers/steps/vehicle/Step3/forms/AdditionalInsureeInfoForm/AdditionalPolicyHolderInfoForm'
import { AdditionalPolicyHolderInfoForm } from '@/containers/steps/vehicle/Step3/forms/AdditionalInsureeInfoForm/AdditionalPolicyHolderInfoForm'
import { FormControl, Stack, Switch } from '@chakra-ui/react'
import { Selection } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'
import type { Step3FormValues } from '../Step3'


export const AdditionalPolicyHolderTravelInfoForm = ({ personPrefix }: AdditionalPolicyHolderInfoFormProps) => {
  const {
    watch
  } = useFormContext<Step3FormValues>()

  const phType = watch('policyHolder.type')
  const insurees = watch('insurees') ?? []

  const isPolicyHolderInsureed = insurees.findIndex(x => x.isPolicyHolder) >= 0

  return (
    <Stack gap={8}>
      <AdditionalPolicyHolderInfoForm personPrefix={personPrefix} />

      {isIn(phType, Selection.Person, Selection.SelfEmployed) && insurees &&
                <FormControl>
                  <FormLabel gap={4}>
                    Je zároveň pojištěnou osobou
                    <Switch
                      size="lg"
                      dir="rtl"
                      checked={isPolicyHolderInsureed}
                      defaultChecked={isPolicyHolderInsureed}
                      isDisabled={true}
                    />
                  </FormLabel>
                </FormControl>

      }
    </Stack>
  )
}
